import Uploader from "../common/Uploader";
import LanguageSelector from "../business/selectors/LanguageSelector";
import {Input} from "@heroui/input";
import {DirectOfferVariant} from "../../types";
import {useAppDispatch} from "../../hooks/redux";
import {updateVariant} from "../../store/slices/beDirectSlice";

export default function DirectOfferVariantItem ({ variant } : { variant: DirectOfferVariant }) {

    const dispatch = useAppDispatch()

    function handleUploadImage (data: any) {
        dispatch(updateVariant({
            ...variant,
            coverUrl: data.data.uploadURL
        }))
    }

    return (
        <div className={'flex space-x-20 p-8'}>
            <div className={'flex w-[350px] flex-col space-y-4'}>
                <div className="text-slate-500 font-medium">Immagine annuncio</div>
                <Uploader
                    fileType={'image'}
                    type={'dashboard'}
                    height={'200px'}
                    folderKey={'be-direct-gallery'}
                    fileKey={'image'}
                    onUpload={(data: any) => handleUploadImage(data)}
                />

                <LanguageSelector defaultValue={variant.languages ? new Set(variant.languages.map(c => c.idCountry.toString())) : new Set()} onChange={val => {
                    dispatch(updateVariant({
                        ...variant,
                        languages: val
                    }))
                }} />

                <Input variant="bordered" value={variant.title} label="Titolo" type="text" onValueChange={val => {
                    dispatch(updateVariant({
                        ...variant,
                        title: val
                    }))
                }} />

                {
                    variant.bullets.map((bullet, key) => (
                        <Input variant="bordered" value={bullet.content} label={`Benefit ${key + 1}`} type="text" key={`benefit-input-${key}`} onValueChange={val => {
                            dispatch(updateVariant({
                                ...variant,
                                bullets: variant.bullets.map((b, i) => {
                                    if (i === key) return { ...b, content: val}
                                    return b
                                })
                            }))
                        }} />
                    ))
                }

                <button className={'text-orange-600 font-medium'} onClick={() => {
                    dispatch(updateVariant({
                        ...variant,
                        bullets: [
                            ...variant.bullets,
                            { content: '', bulletOrder: 0 }
                        ]
                    }))
                }}>
                    Aggiungi benefit
                </button>

                <Input
                    variant="bordered"
                    startContent={
                        <div className="pointer-events-none flex items-center">
                            <span className="text-default-400 text-small">https://</span>
                        </div>
                    }
                    value={variant.ctaLink}
                    label="Link CTA"
                    type="text"
                    onValueChange={val => {
                        dispatch(updateVariant({
                            ...variant,
                            ctaLink: val
                        }))
                    }}
                />
            </div>
            <div className={'flex flex-col justify-center items-center'}>
                <div className={'flex flex-col bg-white overflow-hidden border border-slate-200 shadow-lg text-slate-700 rounded-md w-96'}>

                    <div className={'h-48 w-full bg-cover bg-center relative'} style={{
                        backgroundImage: `url(${variant.coverUrl ? variant.coverUrl : 'https://i.imgur.com/IMxaWRT.jpeg'})`
                    }}>
                    </div>

                    <div className={'p-4'}>
                        <div className={'font-semibold mb-2'}>
                            {variant.title}
                        </div>

                        <div>
                            <ul className={'list-disc px-4'}>
                                {
                                    variant.bullets.map((b, i) => (
                                        <li key={`benefit-preview${i}`}>{b.content}</li>
                                    ))
                                }
                            </ul>
                        </div>

                        <div className="flex-col space-y-1 border-t mt-4 pt-4">
                            <div className="bg-green-100 p-2 rounded-md flex space-x-4 items-center justify-between text-green-700">
                                <div className={'flex space-x-4 items-center'}>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                            <path fillRule="evenodd" d="M8.603 3.799A4.49 4.49 0 0 1 12 2.25c1.357 0 2.573.6 3.397 1.549a4.49 4.49 0 0 1 3.498 1.307 4.491 4.491 0 0 1 1.307 3.497A4.49 4.49 0 0 1 21.75 12a4.49 4.49 0 0 1-1.549 3.397 4.491 4.491 0 0 1-1.307 3.497 4.491 4.491 0 0 1-3.497 1.307A4.49 4.49 0 0 1 12 21.75a4.49 4.49 0 0 1-3.397-1.549 4.49 4.49 0 0 1-3.498-1.306 4.491 4.491 0 0 1-1.307-3.498A4.49 4.49 0 0 1 2.25 12c0-1.357.6-2.573 1.549-3.397a4.49 4.49 0 0 1 1.307-3.497 4.49 4.49 0 0 1 3.497-1.307Zm7.007 6.387a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clipRule="evenodd" />
                                        </svg>
                                    </div>
                                    <div className={'font-bold'}>Direct Website</div>
                                </div>
                                <div>
                                    280,00 €
                                </div>
                            </div>

                            <div className="flex p-2 space-x-4 items-center justify-between opacity-70">
                                <div className={'flex space-x-4 items-center'}>
                                    <div><img src="https://cdn.worldvectorlogo.com/logos/bookingcom-1.svg" className={'w-6'} alt=""/></div>
                                    <div className={'font-medium'}>Booking.com</div>
                                </div>
                                <div>
                                    300,00 €
                                </div>
                            </div>
                        </div>

                        <div className={'mt-8 flex space-x-2'}>
                            <button className={'cursor-pointer  hover:bg-slate-950 bg-slate-900 text-white rounded-md px-4 py-2 font-medium text-sm'}>
                                Prenota l'offerta
                            </button>

                            <button className={'cursor-pointer  hover:bg-slate-100 text-slate-600 rounded-md px-4 py-2 font-medium text-sm'}>
                                No grazie
                            </button>
                        </div>
                    </div>
                </div>

                <div className={'max-w-sm text-slate-500 mt-6 text-center text-sm'}>
                    Anteprima del tuo annuncio che verrà mostrata sul tuo sito web una volta che avrai integrato lo script BeDirect.
                    L'annuncio viene visualizzato nella lingua dell'utente, se hai inserito più varianti vengono testate in automatico
                    per verificare quella più efficace.
                </div>
            </div>
        </div>
    )

}
